var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "asta-tavolo-griglia" },
    [
      _vm.asta_round.calciatoreInAsta
        ? _c("calciatore-battuto", {
            attrs: { id: _vm.asta_round.calciatoreInAsta },
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "draggable",
        {
          attrs: {
            disabled: !this.admin || this.isAstaInCorso,
            "ghost-class": "ghost",
            animation: "150",
            group: "squadre-tavolo",
            delay: "80",
            delayOnTouchOnly: "true",
          },
          model: {
            value: _vm.asta_squadre_drag,
            callback: function ($$v) {
              _vm.asta_squadre_drag = $$v
            },
            expression: "asta_squadre_drag",
          },
        },
        [
          _c(
            "transition-group",
            { staticClass: "lista-squadre" },
            _vm._l(_vm.asta_squadre_array, function (sq) {
              return _c(
                "div",
                { key: sq.id },
                [_c("squadra-tavolo", { attrs: { id: sq.id } })],
                1
              )
            }),
            0
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }